import * as Yup from "yup";
import { transformSnakeToCamel } from "utils/transform";
import { PHONE_REGEX, ERROR_MESSAGES } from "constants/validation";

/**
 * Admin Schema
 * Represents an admin in the affiliate system
 * Base schema is loose to allow loading legacy data.
 */
export const AdminSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    id: Yup.string().nullable(),
    email: Yup.string().nullable(),
    firstName: Yup.string().nullable(),
    lastName: Yup.string().nullable(),
    phoneNo: Yup.string().nullable(),
    profilePicture: Yup.string().nullable(),
    birthdate: Yup.date().nullable(),
    isVerified: Yup.boolean().default(false),
    isActive: Yup.boolean().default(true),
    lastActiveAt: Yup.date().nullable(),
    createdAt: Yup.date().nullable(),
    updatedAt: Yup.date().nullable(),
  });

/**
 * Admin Validation Schema
 * Strict rules applied only during form submission.
 */
export const AdminValidationSchema = AdminSchema.clone().shape({
  email: Yup.string()
    .required(ERROR_MESSAGES.EMAIL_REQUIRED)
    .email(ERROR_MESSAGES.INVALID_EMAIL),
  firstName: Yup.string()
    .required(ERROR_MESSAGES.FIRST_NAME_REQUIRED)
    .min(2, ERROR_MESSAGES.MIN_CHARS(2)),
  lastName: Yup.string()
    .required(ERROR_MESSAGES.LAST_NAME_REQUIRED)
    .min(2, ERROR_MESSAGES.MIN_CHARS(2)),
  phoneNo: Yup.string()
    .nullable()
    .matches(PHONE_REGEX, ERROR_MESSAGES.PHONE_FORMAT),
});
